module.exports = __webpack_public_path__ + "img/ceramic-magenta.1ba3870d.webp";